import { useEffect, useState } from 'react';
import { api, liste, datum, menge, type Anmelder } from '../api.ts';
import { Kopf, Karte, Kachel, Leer } from '../teile/Geruest.tsx';
import { Dialog } from '../teile/Formular.tsx';
import Behoerdenmappe from './Behoerdenmappe.tsx';
import { useFrisch } from '../teile/Frisch.tsx';

export default function Behoerden({
  ich, oeffne,
}: {
  ich: Anmelder;
  oeffne: (id: string, reiter?: string) => void;
}) {
  const [d, setD] = useState<any>(null);
  const [fehler, setFehler] = useState<string | null>(null);
  /* DIE MAPPE OEFFNET SICH HIER, NICHT WOANDERS.
   *
   * ORIGINALTEXT MARVIN (26.08.2026)
   *   „Wie bereits gesagt mir fehlt die Bedienung. Es sieht alles noch zu
   *    sehr nach ,einfach nur gucken' aus"
   *
   * Die Knoepfe dieser Uebersicht sind bis zum 26.08.2026 nur GESPRUNGEN:
   * sie haben die Auftragsakte geoeffnet, Reiter Behoerde. Fuenf Zeilen
   * abzuarbeiten hiess fuenfmal hin und fuenfmal mit dem Rueckenknopf
   * zurueck, und danach war die Liste neu geladen und man suchte die
   * Zeile wieder. Jetzt legt sich die Mappe ueber die Liste, und die Liste
   * bleibt darunter stehen. Der Weg in die ganze Akte bleibt daneben. */
  const [mappe, setMappe] = useState<any>(null);
  async function laden() {
    try { setD(await api.behoerden()); } catch (f: any) { setFehler(f.message); }
  }
  useEffect(() => { laden(); }, []);
  useFrisch(laden);

  if (fehler) return <div className="inhalt"><div className="hinweis fehler">{fehler}</div></div>;
  if (!d) return null;

  /* DIE AMPEL KOMMT JETZT VOM SERVER, NICHT AUS EINEM VERGLEICH HIER.
   *
   * Hier stand ein `tage_bis_frist <= 14 && !f.hat_faz` und daneben in der
   * Tabelle noch einmal dasselbe mit anderen Grenzen. Die Regel dazu
   * (`regeln/termine.ts: vaoampel`) gab es die ganze Zeit, sie ist gegen echte
   * Fälle geprüft, und niemand hat sie gerufen: die Oberfläche hat sie
   * zweimal nachgebaut, mit zwei verschiedenen Fenstern.
   *
   * Ihr Kern ist der, den ein Vergleich nicht mitbringt: liegt die
   * Fertigstellungsanzeige vor, wird NICHT mehr gewarnt. Die Baustelle ist
   * abgemeldet. Wer jeden Tag fünf rote Zahlen sieht, von denen vier keine
   * mehr sind, sieht die fünfte auch nicht.
   */
  const bald = d.fristen.filter((f: any) => f.ampel === 'warnung');
  const abgelaufen = d.fristen.filter((f: any) => f.ampel === 'abgelaufen');

  /* EINE LISTE, DIE NUR ALTLASTEN ZEIGT, WIRD NICHT GELESEN.
   *
   * ORIGINALTEXT MARVIN (25.08.2026)
   *   „hier bei der behördenmappe stimmt die übersicht nicht. was
   *    interessieren mich diese altlasten?"
   *
   * In der Karte standen Fristen von vor 185 Tagen, jede einzelne
   * abgemeldet, und die Überschrift sagte dazu „(0 in 14 Tagen)". Das ist
   * keine Übersicht, das ist ein Archiv mit einer falschen Beschriftung.
   *
   * Eine Anordnung mit Fertigstellungsanzeige ist ERLEDIGT. Sie verschwindet
   * trotzdem nicht - sie steht zugeklappt darunter, denn manchmal sucht man
   * genau sie. Aber sie steht nicht mehr da, wo man nachsieht, was zu tun
   * ist. */
  const laufend = d.fristen.filter((f: any) => !f.hat_faz);
  const abgemeldet = d.fristen.filter((f: any) => f.hat_faz);

  return (
    <>
      <Kopf titel="Behördenmappe"
            weg="Aufgrabung, Anordnung, Fertigstellung" />
      <div className="inhalt">

        <div className="kachelreihe">
          <Kachel wert={d.zahlen.aaz} was="Aufgrabungsanzeigen" />
          <Kachel wert={d.zahlen.anordnung} was="Anordnungen der Behörde" />
          <Kachel wert={d.zahlen.faz} was="Fertigstellungsanzeigen" />
          <Kachel wert={d.zahlen.bescheid} was="Gebührenbescheide" />
          <Kachel wert={abgelaufen.length} was="Frist abgelaufen, keine FAZ"
                  farbe={abgelaufen.length ? 'var(--ueberfaellig)' : undefined} />
          <Kachel wert={d.ungeprueft.n} was="Fristen ungeprüfter Herkunft"
                  farbe={d.ungeprueft.n ? 'var(--neu)' : undefined} />
        </div>

        <Karte titel={'Fristen, die als Nächstes ablaufen'
                      + (laufend.length ? ` (${laufend.length} offen`
                          + (bald.length ? `, ${bald.length} in 14 Tagen` : '')
                          + ')' : '')}>
          {laufend.length === 0 ? (
            <Leer text={abgemeldet.length
              ? `Keine offene Frist. ${abgemeldet.length} Anordnungen sind `
                + 'abgemeldet und stehen unten.'
              : 'Keine laufende Anordnung.'} />
          ) : (
            <table className="liste">
              <thead>
                <tr>
                  <th style={{ width: 100 }}>Läuft ab</th>
                  <th style={{ width: 80 }}>in Tagen</th>
                  <th>Baustelle</th>
                  <th style={{ width: 160 }}>Gemeinde</th>
                  <th style={{ width: 130 }}>Aktenzeichen</th>
                  <th style={{ width: 80 }}>FAZ</th>
                </tr>
              </thead>
              <tbody>
                {laufend.slice(0, 40).map((f: any) => (
                  <tr key={f.auftrag_id}
                      title="Öffnet die Behördenmappe dieses Auftrags"
                      onClick={() => setMappe({
                        id: f.auftrag_id,
                        was: `${f.strasse} ${f.hausnummer}, ${f.ort_text}`,
                      })}>
                    <td className="klein">{datum(f.gueltig_bis)}</td>
                    <td className="zahl klein" style={{
                      color: f.ampel === 'abgelaufen' ? 'var(--ueberfaellig)'
                           : f.ampel === 'warnung' ? 'var(--neu)' : undefined,
                      fontWeight: f.ampel === 'gruen' ? 400 : 600,
                    }} title={f.hat_faz
                      ? 'Fertigstellungsanzeige liegt vor: die Baustelle ist '
                        + 'abgemeldet, die Frist warnt nicht mehr.'
                      : undefined}>
                      {f.resttage ?? f.tage_bis_frist}
                      {f.hat_faz && (
                        <div className="klein leise"
                             style={{ fontWeight: 400 }}>abgemeldet</div>
                      )}
                    </td>
                    <td>
                      {f.strasse} {f.hausnummer}
                      <span className="leise klein">, {f.ort_text}</span>
                      {!f.frist_geprueft && (
                        <div className="klein" style={{ color: 'var(--neu)' }}>
                          Herkunft der Frist ungeprüft
                        </div>
                      )}
                    </td>
                    <td className="klein">{f.gemeinde ?? '-'}</td>
                    <td className="klein leise">{f.aktenzeichen ?? '-'}</td>
                    <td className="klein">
                      {f.hat_faz
                        ? <span className="marke-zustand z-erledigt">da</span>
                        : <span className="leise">offen</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* NICHTS VERSCHWINDET STILL. Die abgemeldeten Baustellen sind
              erledigt und gehören nicht in die Arbeitsliste - aber sie sind
              da, und manchmal sucht man genau eine davon. Zugeklappt. */}
          {abgemeldet.length > 0 && (
            <details style={{ marginTop: 12 }}>
              <summary className="klein">
                {abgemeldet.length} abgemeldet: Anordnung abgelaufen,
                Fertigstellungsanzeige liegt vor
              </summary>
              <table className="liste" style={{ marginTop: 8 }}>
                <thead>
                  <tr>
                    <th style={{ width: 100 }}>Lief ab</th>
                    <th>Baustelle</th>
                    <th style={{ width: 160 }}>Gemeinde</th>
                    <th style={{ width: 130 }}>Aktenzeichen</th>
                  </tr>
                </thead>
                <tbody>
                  {abgemeldet.slice(0, 60).map((f: any) => (
                    <tr key={f.auftrag_id} onClick={() => oeffne(f.auftrag_id)}>
                      <td className="klein leise">{datum(f.gueltig_bis)}</td>
                      <td className="klein">
                        {f.strasse} {f.hausnummer}
                        <span className="leise">, {f.plz} {f.ort_text}</span>
                      </td>
                      <td className="klein leise">{f.gemeinde ?? '-'}</td>
                      <td className="klein leise">{f.aktenzeichen ?? '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {abgemeldet.length > 60 && (
                <p className="klein leise">
                  Die ältesten {abgemeldet.length - 60} stehen nicht mehr hier.
                  Sie sind über die Auftragsakte erreichbar.
                </p>
              )}
            </details>
          )}
        </Karte>

        <Karte titel={`Öffentlicher Grund ohne Anordnung (${d.offen.length})`}>
          <p className="klein leise" style={{ marginTop: 0 }}>
            Diese Aufträge haben Tiefbau im öffentlichen Grund, aber keine
            Anordnung der Behörde. Vor dem Termin muss eine vorliegen.
          </p>
          {d.offen.length === 0 ? <Leer text="Nichts offen." /> : (
            <table className="liste">
              <thead>
                <tr>
                  <th>Baustelle</th><th style={{ width: 170 }}>Gemeinde</th>
                  <th style={{ width: 100 }}>Vorlauf</th>
                  <th style={{ width: 110 }}>Tiefbau am</th>
                  <th style={{ width: 90 }}>AAZ</th>
                  <th style={{ width: 140 }} />
                </tr>
              </thead>
              <tbody>
                {d.offen.slice(0, 30).map((o: any) => (
                  <tr key={o.id}>
                    <td>{o.strasse} {o.hausnummer}
                      <span className="leise klein">, {o.plz} {o.ort_text}</span></td>
                    <td className="klein">
                      {o.gemeinde ?? '-'}
                      {o.gemeinde && !o.gepflegt && (
                        <div style={{ color: 'var(--ueberfaellig)' }}>nicht gepflegt</div>
                      )}
                    </td>
                    <td className="zahl klein">{o.vorlauf_tage ?? 7} Tage</td>
                    <td className="klein">{o.tb_termin ? datum(o.tb_termin)
                      : <span className="leise">kein Termin</span>}</td>
                    <td className="klein">
                      {o.hat_aaz ? <span className="marke-zustand z-erledigt">da</span>
                                 : <span className="leise">fehlt</span>}
                    </td>
                    {/* DER HANDGRIFF ZUR MELDUNG.
                        Marvin, 25.08.2026: „wo kann ich manuell AAZ/VAO/FAZ/
                        Poller erstellen?" und „ich habe den eindruck als ist
                        die ganze zeit derzeit sehr ,nur anschauen aber nicht
                        bearbeiten' lastig."
                        Beides hat dieselbe Ursache: der Weg gibt es, er liegt
                        im Reiter „Behörde" einer Akte, und diese Liste konnte
                        die Akte nur AUFMACHEN - auf der Übersicht. Fünf
                        Zeilen abarbeiten hiess fünfmal den Reiter suchen.
                        Jetzt führt die Zeile dorthin, wo das Papier entsteht. */}
                    <td>
                      <div className="reihe">
                        <button className="knopf klein haupt"
                                onClick={() => setMappe({
                                  id: o.id,
                                  was: `${o.strasse} ${o.hausnummer}, ${o.ort_text}`,
                                })}>
                          Papier erzeugen
                        </button>
                        <button className="knopf klein"
                                onClick={() => oeffne(o.id, 'behoerde')}>
                          zur Akte
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Karte>

        {/* WER IST NICHT VORBEREITET?
            Früher ein eigener Menüpunkt, hier eine Karte an der Stelle, an
            der die Frage aufkommt. Sie beantwortet die teuerste Frage dieses
            Bildschirms: für welchen Auftrag steht ein Tiefbautermin, ohne dass
            die Angaben für AAZ und VAO vollständig sind. */}
        <Karte
          titel={`Nicht vorbereitet (${(d.unvorbereitet ?? []).length})`}
        >
          <p className="klein leise" style={{ marginTop: 0 }}>
            Ohne vollständige Angaben lässt sich weder eine Aufgrabungsanzeige
            noch ein Antrag auf verkehrsrechtliche Anordnung erzeugen. Privater
            Grund steht nicht darin: dort braucht es keine Anordnung.
          </p>
          {!(d.unvorbereitet ?? []).length ? (
            <Leer text="Jeder Auftrag im öffentlichen Grund ist vorbereitet." />
          ) : (
            <table className="liste">
              <thead>
                <tr>
                  <th style={{ width: 110 }}>KLS</th>
                  <th>Baustelle</th>
                  <th style={{ width: 190 }}>Gemeinde</th>
                  <th style={{ width: 140 }}>Tiefbautermin</th>
                  <th style={{ width: 150 }}>Angaben</th>
                </tr>
              </thead>
              <tbody>
                {d.unvorbereitet.map((u: any) => {
                  const fehlt = Number(u.pflichtfelder) - Number(u.gefuellt);
                  return (
                    <tr key={u.id} onClick={() => oeffne(u.id)}>
                      <td>{u.kls_id}</td>
                      <td>
                        {u.strasse} {u.hausnummer}
                        <div className="klein leise">
                          {u.plz} {u.ort_text}
                        </div>
                      </td>
                      <td className="klein">{u.gemeinde ?? ''}</td>
                      <td className={'klein' + (u.tb_termin ? ' rot' : '')}>
                        {u.tb_termin
                          ? datum(u.tb_termin)
                          : <span className="leise">noch keiner</span>}
                      </td>
                      <td className="klein">
                        {/* Eine Zahl, die kleiner geworden ist, braucht ihren
                            Grund daneben: hier steht, WIE VIELE fehlen. */}
                        {u.pflichtfelder
                          ? `${u.gefuellt} von ${u.pflichtfelder}`
                            + (fehlt > 0 ? `, ${fehlt} fehlen` : '')
                          : <span className="leise">nie geöffnet</span>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </Karte>

        {d.portal.length > 0 && (
          <Karte titel="Gemeinden mit eigenem Portal">
            <p className="klein leise" style={{ marginTop: 0 }}>
              Diese Behörden erwarten die genannten Papiere über ihr Portal, nicht
              per Mail. Dort entsteht kein Versandstempel, deshalb hat das System
              dafür einen eigenen Zustand.
            </p>
            {d.portal.map((p: any) => (
              <div key={p.name} className="reihe" style={{ marginBottom: 6 }}>
                <b>{p.name}</b>
                {liste(p.portal_wege).map((w: string) => (
                  <span key={w} className="gewerk">{w}</span>
                ))}
                <a className="klein" href={p.portal_url} target="_blank" rel="noreferrer">
                  {p.portal_url}
                </a>
              </div>
            ))}
          </Karte>
        )}
      </div>

      {mappe && (
        <Dialog titel="Behördenmappe" untertitel={mappe.was} breite={1000}
                zu={() => { setMappe(null); laden(); }}>
          <Behoerdenmappe ich={ich} auftragId={mappe.id} />
          <div className="reihe" style={{ marginTop: 14 }}>
            <button className="knopf" onClick={() => oeffne(mappe.id)}>
              die ganze Akte öffnen
            </button>
          </div>
        </Dialog>
      )}
    </>
  );
}
